import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { PageHeader } from '@/components/PageHeader';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  const { isAuthenticated } = useAuth();
  return <div className="container mx-auto w-full px-4 py-8">
    <PageHeader title="Page not found" description="This page may have moved, or the address may be incorrect." />
    <div className="flex flex-wrap gap-3">
      <Button asChild><Link to={isAuthenticated ? '/' : '/login'}>{isAuthenticated ? 'Go to Dashboard' : 'Go to Login'}</Link></Button>
      {isAuthenticated && <Button variant="outline" asChild><Link to="/tests">Browse Tests</Link></Button>}
    </div>
  </div>;
}
